import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'standardDate',
})
export class StandardDatePipe implements PipeTransform {
    transform(value: string, ...args) {

        let dateValue = new Date(value);
        let formattedDate = (dateValue.getMonth() + 1) + '/' + dateValue.getDate() + '/' + dateValue.getFullYear();
        return formattedDate;
    }
}



// WEBPACK FOOTER //
// ./src/pipes/standard-date/standard-date.ts